import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { SidebarNavItemProps } from './types';
import { styles } from './styles';

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  to,
  icon,
  label,
  isActive,
  collapsed,
}) => (
  <Link to={to} className={clsx(styles.navItem, isActive && styles.navItemActive)}>
    <FontAwesomeIcon icon={icon} className={styles.navIcon} />
    <span
      className={clsx(styles.navLabel, collapsed ? styles.navLabelHidden : styles.navLabelVisible)}>
      {label}
    </span>
    {collapsed && <span className={styles.tooltip}>{label}</span>}
  </Link>
);

export default SidebarNavItem;
